import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IStoreEventState, TStoreEvents } from './storeEvent.models'

const initialState: IStoreEventState = {
  eventType: undefined,
}

const storeEventSlice = createSlice({
  name: 'storeEvent',
  initialState,
  reducers: {
    setStoreEvent(state, action: PayloadAction<TStoreEvents>) {
      state.eventType = action.payload
    },
    resetStoreEvent() {
      return initialState
    },
  },
})

export const { setStoreEvent, resetStoreEvent } = storeEventSlice.actions

export default storeEventSlice.reducer
